import PresupuestosRankingPrestadoresContainer from './PresupuestosRankingPrestadoresContainer';

export default PresupuestosRankingPrestadoresContainer;
